  
// ---- Read More button START -----
(function () {
  function initPageReadMore() {
    var wraps = document.querySelectorAll('[data-page-readmore]');
    if (!wraps || !wraps.length) return;

    for (var i = 0; i < wraps.length; i++) {
      (function (wrap) {
        var link = wrap.querySelector('[data-page-readmore-link]');
        var more = wrap.querySelector('.page-readmore__more');
        if (!link || !more) return;

        link.setAttribute('role', 'button');
        link.setAttribute('tabindex', '0');

        function expand() {
          wrap.classList.add('is-expanded');
          link.setAttribute('aria-expanded', 'true');
        }

        link.addEventListener('click', function () {
          expand();
        });

        link.addEventListener('keydown', function (e) {
          var key = e.key || e.keyCode;
          if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
            e.preventDefault();
            expand();
          }
        });
      })(wraps[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageReadMore);
  } else {
    initPageReadMore();
  }
})();
// ---- Read More button END -----



// ---- Hero image fade-in START -----


(function () {
  function initHeroFade() {
    var wraps = document.querySelectorAll('[data-hero-fade]');
    if (!wraps || !wraps.length) return;

    for (var i = 0; i < wraps.length; i++) {
      (function (wrap) {
        var img = wrap.querySelector('img');
        if (!img) return;

        function reveal() {
          img.style.opacity = '1';
        }

        // If cached and already complete, reveal immediately.
        if (img.complete) {
          reveal();
          return;
        }

        // Prefer decode() when available to avoid half-painted frames.
        if (img.decode) {
          img.decode().then(reveal).catch(function () {
            // decode can fail even when load succeeds
          });
        }

        img.addEventListener('load', reveal);
      })(wraps[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroFade);
  } else {
    initHeroFade();
  }
})();
// ---- Hero image fade-in END -----
